import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";

let $ = window.$;
class OrderSummary extends Component {
  state = {
    stickyY: 0,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleSticky);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleSticky);
  }

  handleSticky = () => {
    const width = document.body.offsetWidth;
    const element = document.getElementById("order-sticky");
    const stickyWidth = document.getElementById("order-sticky-content")
      .offsetWidth;
    const elementOffsetTop = document.getElementById("sticky-top").offsetTop;
    const elementHeight = document.getElementById("sticky-top").offsetHeight;
    // const headerHeight = document.getElementById("header-content").offsetHeight;
    const titleHeight = document.getElementById("checkout-title").offsetHeight;
    const stopPostion = elementHeight - element.offsetHeight;
    const endStickyPosition = elementOffsetTop;
    if (width > 767) {
      if (window.pageYOffset > elementOffsetTop) {
        if (window.pageYOffset < stopPostion) {
          element.style.position = "fixed";
          element.style.width = `${stickyWidth}px`;
          element.style.top = `calc(4.375rem + ${titleHeight}px)`;
          element.style.transform = `translate3d(0,0,0)`;
          const stickyY = window.pageYOffset - endStickyPosition;
          this.setState({
            stickyY: stickyY,
          });
        } else {
          const { stickyY } = this.state;
          element.style.position = "";
          element.style.top = "";
          element.style.transform = `translate3d(0,${stickyY}px,0)`;
        }
      } else {
        element.style.position = "";
        element.style.width = "";
        element.style.transform = `translate3d(0,0,0)`;
      }
    }
  };

  render() {
    const { getMyBagSuccessfully, myBagData } = this.props;
    const pdt = {
      totalDiscountAmount: myBagData.totalDiscountAmount,
      shippingFee: myBagData.shippingFee,
      shippingFeeDiscount: myBagData.shippingFeeDiscount,
      discountCode: myBagData.discountCode,
      totalNetAmount: myBagData.totalNetAmount,
      estimatedDeliveryDate: myBagData.estimatedDeliveryDate,
      estimatedDutyTax: myBagData.estimatedDutyTax,
    };
    return (
      <>
        {getMyBagSuccessfully && (
          <div className="order_summary" ref="sticky">
            <Translation>
              {(t) => <div className="title">{t("checkout.orderSummary")}</div>}
            </Translation>
            <table className="order_listing_table">
              <tbody>
                <tr>
                  <Translation>
                    {(t) => <td>{t("checkout.subtotal")}</td>}
                  </Translation>
                  <td>{pdt.totalDiscountAmount}</td>
                </tr>

                <tr>
                  <Translation>
                    {(t) => <td>{t("checkout.shippingCost")}</td>}
                  </Translation>
                  <td>{pdt.shippingFee}</td>
                </tr>

                {myBagData.campaignAmount ? (
                  <tr>
                    <td>
                      <Translation>
                        {(t) => t("checkout.promotion")}
                      </Translation>
                      ({myBagData.campaignDescription}):
                    </td>
                    <td>- {myBagData.campaignAmount}</td>
                  </tr>
                ) : null}

                {myBagData.couponAmount ? (
                  <tr>
                    <Translation>
                      {(t) => <td>{t("checkout.coupon")}</td>}
                    </Translation>
                    <td>- {myBagData.couponAmount}</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
            <table className="order_conclusion_table">
              <tbody>
                <tr>
                  <Translation>
                    {(t) => <td>{t("checkout.total")}</td>}
                  </Translation>
                  <td className="text-gold">{pdt.totalNetAmount}</td>
                </tr>
                <tr>
                  <Translation>
                    {(t) => (
                      <td>{t("checkout.estimatedDutiesTaxesCharges")}</td>
                    )}
                  </Translation>
                  <td>{pdt.estimatedDutyTax}</td>
                </tr>
              </tbody>
            </table>
            <table className="order_moreInfo_table">
              <tbody>
                <tr>
                  <Translation>
                    {(t) => <td>{t("checkout.estimatedDeliveryDate")}</td>}
                  </Translation>
                  <td>
                    {
                      //當step1的時候，不要顯示預計到貨日。
                      !$("section.checkout_pdts").hasClass("opened") && (
                    <span className="d-inline-block">
                      {pdt.estimatedDeliveryDate
                        ? new Date(
                            pdt.estimatedDeliveryDate.substring(
                              0,
                              pdt.estimatedDeliveryDate.indexOf("T")
                            )
                          ).toLocaleDateString("zh-TW")
                        : ""}
                    </span>
                      )
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
    myBagData: state.myBag.myBagData,
  };
};

export default connect(mapStateToProps)(OrderSummary);
